import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { StoreLocatorBg } from '@next-nx/shared-ui/icons'
import { Button, WContainer } from '@next-nx/shared-ui/atoms'
import { useTealium } from '@next-nx/hooks'
import { getTimestamp } from '@next-nx/utils'
import styles from './StoreLocatorBanner.module.sass'


interface Props {
  item: MenuItemType | undefined
  className?: string
}

const StoreLocatorBanner = (props: Props) => {

  const { 
    item = undefined,
    className = '',
  } = props

  const { linkDataLayer } = useTealium()

  const handleTracking = (action_type?: string, c?: string, t?: string, cta?: string) => {
    const action_timestamp = getTimestamp()

    linkDataLayer({
      virtual: 'action',
      action_name: 'navigazione',
      action_tech: 'click',
      action_type: cta?.replace(/ /g, '_').toLowerCase(),
      action_timestamp,
      action_effect: 'interazione_componente_storelocator',
    })
  }

  return item ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer>
        <div className={styles.content}>
          {!!item.name && <p className={styles.title}>{item.name}</p>}
          {!!item.ctaLabel && !!item.url && (
            <div className={styles.ctaBox}>
              <Button label={item.ctaLabel} href={item.url} newPage={item.blank} color="white" variant='secondary' handleTracking={handleTracking} />  
            </div>
          )}
        </div>
      </WContainer>
      <div className={styles.bg}>
        <StoreLocatorBg />
      </div>
    </div>
  ) : <></>
}

export default StoreLocatorBanner
